import { jsx as _jsx } from "react/jsx-runtime";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, } from "chart.js";
import { Line } from "react-chartjs-2";
import { useEffect, useMemo, useRef } from "react";
import { BankAccountCurrency } from "@bundles/UIAppBundle/collections/BankAccounts/enum";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
const LineChart = ({ title, colors = ["rgba(70,70,175,0.8)"], labels, data, className, }) => {
    const containerRef = useRef();
    const getLineChartOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: title,
            },
            tooltip: {
                callbacks: {
                    label: (item) => `${item.label}: ${item.formattedValue} ${BankAccountCurrency.RON}`,
                },
            },
        },
    }), [title]);
    const getLineChartData = useMemo(() => ({
        labels,
        datasets: Array.from({ length: data.length }).map((_, index) => ({
            label: labels[index],
            data: data[index],
            borderColor: colors[index],
            backgroundColor: colors[index],
        })),
    }), [labels, data]);
    useEffect(() => {
        var _a;
        if (containerRef.current && window) {
            containerRef.current.scrollTo({
                left: (containerRef.current.scrollWidth -
                    ((_a = containerRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.offsetWidth)) /
                    2,
            });
        }
    }, [window, containerRef.current]);
    return (_jsx("div", Object.assign({ ref: containerRef, className: "line-chart-parent-container" }, { children: _jsx("div", Object.assign({ className: "line-chart-container" }, { children: _jsx(Line, { className: className, options: getLineChartOptions, data: getLineChartData }, void 0) }), void 0) }), void 0));
};
export default LineChart;
